import React from "react";
import SubCategoryMenu from "./SubCategoryMenu";
import menuStore from "../../stores/menu";
import { observer } from "mobx-react";
import "./style.scss";
import { ArticleViewType } from "../../@types/enums/ArticleViewType";
import ArticleInfoBlock from "../ArticleInfoBlock";
import Filter from "../Filter";
import {useTranslation} from "react-i18next";
import {ReactComponent as IconScan} from "../../assets/icons/scanArticle.svg";
import {isRetail} from "../../helpers/ApiHelper";
import {useNavigate} from "react-router";
import {ApiGeneral_ScanArrowDirection} from "../../@types/enums/styles";
import useLayoutStyles from "../../hooks/styles";


const Menu = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();
    const styles = useLayoutStyles();

    const goToScan = () => {
        navigate("/scanArticle");
    }

    return <div className="Menu">
        <div className="topMenuButtons">
            <Filter />
            {isRetail()
                ? <div className="button scanBtn" onClick={goToScan}>
                    <IconScan className="icon" />
                    {t(styles?.general.scannerArrowDirection === ApiGeneral_ScanArrowDirection.NO ? "search" : "scanOrSearch")}
                </div>
                : null
            }
        </div>
        {localStorage.getItem("articleViewType") === ArticleViewType.GROUP_PAGE || localStorage.getItem("articleViewType") === ArticleViewType.INDIVIDUAL_PAGE
            ? <ArticleInfoBlock />
            : null
        }
        {menuStore.menu?.find(x => x.id === menuStore.navigation.category)?.submenu?.map(x =>
            <div key={`subCategory_${x.name}`} id={`subCategory_${x.id}`}>
                <SubCategoryMenu category={menuStore.navigation.category} subCategory={x} />
            </div>
        )}

    </div>
}

export default observer(Menu);
